<salonmonster-load-mask *ngIf="isLoading"></salonmonster-load-mask>

<salonmonster-tap-retry
  *ngIf="errorOccurred"
  (click)="loadPage()"
></salonmonster-tap-retry>

<div *ngIf="!isLoading && !errorOccurred">
  <sm-booking-details
    *ngIf="booking.getServices().length > 0"
    [booking]="booking"
    [title]="title"
    [fromSummary]="false"
    [subTitle]="subTitle"
    [hideNotesField]="true"
    (serviceDelete)="removeService($event)"
    [showDeleteButton]="true"
  >
  </sm-booking-details>

  <br />
  <div sm-center>
    <div *ngIf="!showStylistPicker">
      <button
        mat-raised-button
        *ngIf="booking.getServices().length > 0"
        (click)="onContinue()"
        class="smc-button-large smc-button-primary"
      >
        {{ 'BOOKINGS.PICK_TIME' | translate }}
      </button>
      <span *ngIf="!isAnyService" class="smc-or">{{ 'BOOKINGS.OR' | translate }}</span>
      <button
        mat-raised-button
        *ngIf="!isAnyService"
        (click)="addAnotherService()"
        class="smc-button-large smc-button-secondary"
      >
        {{ 'BOOKINGS.ADD_ANOTHER_SERVICE' | translate }}
      </button>
    </div>
  </div>

  <!--   <mat-grid-list *ngIf="showStylistPicker" cols="3">
    <mat-grid-tile
        *ngFor="let stylist of stylists"
        [routerLink]="['/stylists', stylist.getID(), 'services']"
        [colspan]="1"
        [rowspan]="1">
        <mat-card >
          <img mat-card-avatar src='https://salonmonster.com/userfiles/profile_pics/{{stylist.getPhotoUrl()}}' />
          <mat-card-title>
           {{stylist.getFirstName()}} {{stylist.getLastName()}}
           </mat-card-title>
           <mat-card-subtitle>
            {{stylist.getBio()}}
            </mat-card-subtitle>
        </mat-card>    
    </mat-grid-tile>
  </mat-grid-list>
 -->

  <div *ngIf="showStylistPicker">
    <div class="smc-stylist-picker-title">
      <h2>{{ 'BOOKINGS.SELECT_PROVIDER' | translate }}</h2>
    </div>
    <div
      class="smc-stylist-picker-container"
      fxLayout="wrap row"
      fxLayout.xs="column"
      fxLayoutAlign="stretch"
    >
      <div
        *ngIf="showAnyProvider"
        fxFlex="25"
        fxFlex.sm="50"
        fxFlex.md="33.333"
        (click)="onStylistClick(null)"
        class="smc-stylist-any-provider-container"
      >
        <mat-card class="smc-stylist-any-provider" tappable>
          <mat-card-title class="smc-clickable-text">
            {{ 'BOOKINGS.FIRST_AVAILABLE' | translate }}
          </mat-card-title>
          <span class="smc-stylist-subtitle">{{ 'BOOKINGS.ANY_PROVIDER_LABEL' | translate }}</span>
        </mat-card>
      </div>

      <div
        fxFlex="25"
        fxFlex.sm="50"
        fxFlex.md="33.333"
        *ngFor="let stylist of stylists"
        (click)="onStylistClick(stylist)"
        class="smc-stylist-card-container"
      >
        <mat-card class="smc-stylist-card" tappable>
          <img
            mat-card-image
            *ngIf="
              stylist.getPhotoUrl() != undefined && stylist.getPhotoUrl() != ''
            "
            [alt]="stylist.getFirstName() + ' ' + stylist.getLastName()"
            src="{{ environment.PROFILE_PHOTO_ROOT }}{{
              stylist.getPhotoUrl()
            }}"
          />
          <mat-card-title class="smc-clickable-text">
            {{ stylist.getFirstName() }} {{ stylist.getLastName() }}
          </mat-card-title>
          <mat-card-subtitle>
            {{ stylist.getTitle() }}
          </mat-card-subtitle>
        </mat-card>
      </div>
    </div>
  </div>
</div>
